import { CountryCode } from '@doordash/lib-i18n'
import { COUNTRY_SHORTCODES } from '../constants'
import { SupportedCountryCode } from '../models/types'

export const routingLabels = {
  US: 'Routing Number',
  CA: 'Transit Number',
}

export type PaymentData = {
  country?: CountryCode | ''
  currency?: string
  routing_number?: string
  account_number: string
  account_holder_name?: string
  account_holder_type?: string
}

export const countryExcludesRoutingNumber = (
  countryShortName: SupportedCountryCode
): boolean => {
  const countriesExcludingRoutingNumber = [COUNTRY_SHORTCODES.NZ]

  return countriesExcludingRoutingNumber.includes(countryShortName)
}
